const MAKE_MODEL_EXCEPTIONS = [
  // Alphabetical order
  '+EV',
  '200h.',
  '500x',
  'AMG',
  'ASX',
  'BYD',
  'bZ4X',
  'CLA',
  'CLA250',
  'CLA45',
  'ClubSport',
  'D-MAX',
  'EQB',
  'EQE',
  'EQS',
  'ES250',
  'ES300h',
  'EV',
  'EV5',
  'EV6',
  'Fe',
  'FIAT',
  'GLA',
  'GLE',
  'GS200t',
  'i20',
  'i30',
  'i40',
  'iLoad',
  'IONIQ',
  'IS200t',
  'IS250',
  'IS250c',
  'IS300h',
  'IS350',
  'IS350',
  'ix35',
  'KA4',
  'NX200t',
  'NX300h',
  'RAM',
  'RAV4',
  'RX350l',
  'RX450h',
  'RX500h',
  'UX200',
  'UX250h',
  'UX300e',
  'XUV700',
];

const MAKE_MODEL_EXCEPTIONS_MAP = new Map<string, string>(
  MAKE_MODEL_EXCEPTIONS.map((exception) => [exception.toUpperCase(), exception]),
);

export const capitaliseMakeModel = (name: string): string => {
  const splitName = name.split(' ');
  // Capitalise each part of the name
  return splitName.map(capitaliseMakeModelWord).join(' ');
};

const capitaliseMakeModelWord = (word: string): string => {
  const upperCaseWord = word.toUpperCase();
  // Check if there's a manual overwrite
  if (MAKE_MODEL_EXCEPTIONS_MAP.has(upperCaseWord)) {
    return MAKE_MODEL_EXCEPTIONS_MAP.get(upperCaseWord) ?? word;
  }

  // Process the word parts if it's not an exception
  const wordParts = word.split('-');

  const capitalisedWordParts = wordParts.map(capitaliseMakeModelWordPart);

  return capitalisedWordParts.join('-');
};

const capitaliseMakeModelWordPart = (wordPart: string): string => {
  // Don't change the word if it only contains consonant, numbers or dashes or if it's less than 2 characters
  if (!/[aeiouy]+/i.test(wordPart) || wordPart.length <= 2) {
    return wordPart.toUpperCase();
  }

  return wordPart.charAt(0).toUpperCase() + wordPart.slice(1).toLowerCase();
};
